import {Component, Inject, LOCALE_ID} from "@angular/core";
import {environment} from "~environments/environment";
import {Router} from "@angular/router";

@Component({
  template: `
    <ng-container *ngIf="locale === 'en'">
      <app-maintenance-en></app-maintenance-en>
    </ng-container>
    <ng-container *ngIf="locale === 'de'">
      <app-maintenance-de></app-maintenance-de>
    </ng-container>
    <ng-container *ngIf="locale === 'es'">
      <app-maintenance-es></app-maintenance-es>
    </ng-container>
  `,
  styleUrl: './maintenance.scss'
})

export class MaintenanceComponent {
  constructor(@Inject(LOCALE_ID) public locale: string, router: Router) {
    if (environment.maintenanceMode as any !== true) {
      router.navigate(['/manage/clubs']);
    }
  }

}
